module.exports = __webpack_public_path__ + "img/1.dac59ad9.png";